import styled from 'styled-components'

const gapFor = props => props.theme.spacing[props.gap] || props.theme.spacing.md

export const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${gapFor};
  align-items: ${props => props.align || 'stretch'};
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: ${props => props.wrap ? 'wrap' : 'nowrap'};
  align-items: ${props => props.align || 'center'};
  justify-content: ${props => props.justify || 'flex-start'};
  gap: ${gapFor};

  @media (max-width: 768px) {
    flex-wrap: wrap;
  }
`
